/**
 * A sortable column header: the label, and an arrow when it is the
 * active column (a faint up-down icon otherwise). Shared by the /trends
 * leaderboard and the SEO rankings so sorting looks the same.
 */
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";

export default function SortHead({
  label,
  active,
  dir,
  onClick,
  className = "",
}: {
  label: string;
  active: boolean;
  dir: "asc" | "desc";
  onClick: () => void;
  className?: string;
}) {
  const Arrow = dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      className={`items-center gap-1 transition-colors hover:text-gray-700 ${active ? "text-gray-900" : ""} ${className}`}
    >
      <span className="truncate">{label}</span>
      {active
        ? <Arrow className="h-3 w-3 shrink-0" />
        : <ChevronsUpDown className="h-3 w-3 shrink-0 text-gray-300" />}
    </button>
  );
}
